/* Progressive disclosure only. Body and links already exist in server HTML. */
(() => {
  const media = window.matchMedia('(min-width: 750px)');
  document.querySelectorAll('details[data-bochu-selection]').forEach((details) => {
    let interacted = false;
    const hashMatches = () => window.location.hash === `#${details.id}`;
    details.open = media.matches || hashMatches();
    details.querySelector('summary').addEventListener('click', () => { interacted = true; });
    media.addEventListener('change', () => {
      if (media.matches || hashMatches()) details.open = true;
      else if (!interacted) details.open = false;
    });
    document.querySelectorAll('a.bochu-selection-link').forEach((link) => {
      if (link.hash !== `#${details.id}`) return;
      link.addEventListener('click', () => {
        interacted = true;
        details.open = true;
        details.querySelector('summary').focus({ preventScroll: true });
      });
    });
    window.addEventListener('hashchange', () => { if (hashMatches()) details.open = true; });
  });
})();
